import { render, staticRenderFns } from "./CardProject.vue?vue&type=template&id=bf5c73dc"
import script from "./CardProject.vue?vue&type=script&lang=js"
export * from "./CardProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports